import { MasterButton, Modal } from "App/Component/ui";
import { Grid } from "@material-ui/core";
import React, { useContext, useState } from "react";
import { FormContext } from "../../context/FormContext";
import {
  convertToValidPrice,
  defaultToastError,
  defaultToastSuccess,
  isNull,
} from "App/utils/helpers";
import { DISABLED_BUTTON_SUBMIT, instance4 } from "App/constants";
import { SHOW_UPDATE } from "../../../PurchaseOrder/ui/ModalSimpan/ModalSimpan";
import {
  STATUS_OPEN_DRAFT_PEMBELIAN,
  STATUS_PROSES_PEMBELIAN,
  STATUS_SELESAI_PEMBELIAN,
  urlAcceptPembelian,
  urlCreatePembelian,
  urlUpdatePembelian,
} from "../../helpers";
import moment from "moment";
import { SHOW_TUTUP_TRANSAKSI } from "App/Component/layout/Penjualan/InputPenjualan/ui/Perhitungan/Modal/ModalSimpan/ModalSimpan";
import { WarningIcon } from "App/Assets";
import { SHOW_BUKA_KUNCI_TRANSAKSI, SHOW_KUNCI_TRANSAKSI } from "utils/billing";

const SHOW_BUKA_TRANSAKSI = {
  label: "BUKA TRANSAKSI",
  color: "green",
  state: true,
  disabled: false,
};
const SHOW_PROCESS = {
  label: "TUTUP PEMBELIAN",
  color: "danger",
  state: true,
  disabled: false,
};
const ModalSimpan = ({
  setShowModal,
  setNewDataPembelianList,
  listPembelian,
  getListPembelian,
}) => {
  const [disabledBukaTransaksi, setDisabledBukaTransaksi] =
    useState(SHOW_BUKA_TRANSAKSI);
  const [disabledProcess, setDisabledProcess] = useState(SHOW_PROCESS);
  const [disabledUpdate, setDisabledUpdate] = useState(SHOW_UPDATE);
  const [disabledKunci, setDisabledKunci] = useState(SHOW_KUNCI_TRANSAKSI);
  const [disabledBukaKunci, setDisabledBukaKunci] = useState(SHOW_BUKA_KUNCI_TRANSAKSI);
  const [showModalForce, setShowModalForce] = useState(false); // eslint-disabled-line

  const { formData, setFormData } = useContext(FormContext);

  const handleClickBukaTransaksi = async (e) => {
    e.preventDefault();
    setDisabledBukaTransaksi(DISABLED_BUTTON_SUBMIT);
    try {
      if (
        isNull(formData.gudang_id) ||
        isNull(formData.supplier_id) ||
        isNull(formData.kasbank_id)
      ) {
        defaultToastError("Gudang / Supplier / Kas Bank tidak boleh kosong!");
        setDisabledBukaTransaksi(SHOW_BUKA_TRANSAKSI);
      } else {
        const api = await instance4.post(urlCreatePembelian, {
          date: moment(formData.faktur_tgl).format(),
          is_po: formData.is_po,
          po_id: formData.po_id === "" ? null : formData.po_id,
          gudang_id: formData.gudang_id,
          user: formData.user,
          supplier_id: formData.supplier_id,
          faktur_no: formData.faktur_no,
          faktur_tgl: moment(formData.faktur_tgl).format(),
          jatuhtempo_tgl: moment(formData.jatuhtempo_tgl).format(),
          kedatangan_tgl: moment(formData.kedatangan_tgl).format(),
          tagih_tgl: moment(formData.tagih_tgl).format(),
          kasbank_id: formData.kasbank_id,
          coa_code: formData.coa_code,
          status: 1,
          biayalain: 0,
          ongkos: 0,
          potongan: formData.potongan2,
          tax: formData.tax2,
          sisa: 0,
          is_changesellprice: false,
          bayar: 0,
        });
        const res = await api?.data;
        if (res.status === 200) {
          setShowModal(false);
          defaultToastSuccess(res?.message);
          setFormData({
            ...formData,
            id: res?.id,
            status: STATUS_OPEN_DRAFT_PEMBELIAN,
            is_po: formData?.is_po,
          });
          setNewDataPembelianList(res.id);
          getListPembelian(res.id);
        } else {
          defaultToastError(res?.message);
          setDisabledBukaTransaksi(SHOW_BUKA_TRANSAKSI);
        }
      }
    } catch (error) {
      setDisabledBukaTransaksi(SHOW_BUKA_TRANSAKSI);
      defaultToastError(error?.response?.data?.message);
    }
  };

  const handleClickTutup = async (e) => {
    e.preventDefault();
    setDisabledKunci(DISABLED_BUTTON_SUBMIT);
    try {
      if (isNull(formData.gudang_id)) {
        defaultToastError("Gudang tidak boleh kosong!");
        setDisabledKunci(SHOW_TUTUP_TRANSAKSI);
      } else {
        const totalJumlah = await getTotalJumlahPembelian();
        const api = await instance4.post(
          "/wmslogistik/pembelian/closePembelian",
          {
            id: formData.id,
            status: STATUS_PROSES_PEMBELIAN,
            total_jumlah: totalJumlah,
          }
        );
        const res = await api?.data;
        if (res.status === 200) {
          setShowModal(false);
          defaultToastSuccess(res?.message);
          await setNewDataPembelianList(formData.id);
          setFormData({
            ...formData,
            status: STATUS_PROSES_PEMBELIAN,
          });
        } else {
          defaultToastError(res?.message);
          setDisabledKunci(SHOW_TUTUP_TRANSAKSI);
        }
      }
    } catch (error) {
      setDisabledKunci(SHOW_TUTUP_TRANSAKSI);
      defaultToastError(error?.response?.data?.message);
    }
  };

  const handleClickBukaKembali = async (e) => {
    e.preventDefault();
    setDisabledBukaKunci(DISABLED_BUTTON_SUBMIT);
    try {
      if (isNull(formData.gudang_id)) {
        defaultToastError("Gudang tidak boleh kosong!");
        setDisabledBukaKunci(SHOW_BUKA_KUNCI_TRANSAKSI);
      } else {
        const api = await instance4.post(
          "/wmslogistik/pembelian/openPembelian",
          {
            id: formData.id,
          }
        );
        const res = await api?.data;
        if (res.status === 200) {
          setShowModal(false);
          defaultToastSuccess(res?.message);
          await setNewDataPembelianList();
          setFormData({
            ...formData,
            status: STATUS_OPEN_DRAFT_PEMBELIAN,
          });
        } else {
          defaultToastError(res?.message);
          setDisabledBukaKunci(SHOW_BUKA_KUNCI_TRANSAKSI);
        }
      }
    } catch (error) {
      setDisabledBukaKunci(SHOW_BUKA_KUNCI_TRANSAKSI);
      defaultToastError(error?.response?.data?.message);
    }
  };

  const handleClickProcess = async (e) => {
    e.preventDefault();
    setDisabledProcess(DISABLED_BUTTON_SUBMIT);
    try {
      if (formData.gudang_id === "") {
        defaultToastError("Gudang tidak boleh kosong!");
        setDisabledProcess(SHOW_PROCESS);
      } else {
        const api = await instance4.post(urlAcceptPembelian, {
          pembelian_id: formData.id,
          gudang_id: formData.gudang_id,
          status: STATUS_SELESAI_PEMBELIAN,
          is_changesellprice: formData.is_changesellprice,
          force: true,
        });
        const res = await api?.data;
        if (res.status === 200) {
          setShowModal(false);
          defaultToastSuccess(res?.message);
          setFormData({
            ...formData,
            status: STATUS_SELESAI_PEMBELIAN,
          });
          setNewDataPembelianList(formData.id);
          setDisabledProcess(SHOW_PROCESS);
        } else {
          if (res.status === 205) {
            defaultToastSuccess("Berhasil");
            setShowModal(false);
            setFormData({
              ...formData,
              status: STATUS_SELESAI_PEMBELIAN,
            });
            // setShowModalForce(true);
            setDisabledProcess(SHOW_PROCESS);
            setNewDataPembelianList(formData.id);
          } else {
            defaultToastError(res?.message);
            setDisabledProcess(SHOW_PROCESS);
          }
        }
      }
    } catch (error) {
      setDisabledProcess(SHOW_PROCESS);
      defaultToastError(error?.response?.data?.message);
    }
  };

  const handleClickUpdate = async (e) => {
    e.preventDefault();
    setDisabledUpdate(DISABLED_BUTTON_SUBMIT);
    try {
      if (isNull(formData.gudang_id)) {
        defaultToastError("Gudang tidak boleh kosong!");
        setDisabledUpdate(SHOW_UPDATE);
      } else {
        const api = await instance4.post(urlUpdatePembelian, {
          id: formData.id,
          date: moment(formData.faktur_tgl).format(),
          gudang_id: formData.gudang_id,
          user: formData.user,
          supplier_id: formData.supplier_id,
          faktur_no: formData.faktur_no,
          faktur_tgl: moment(formData.faktur_tgl).format(),
          jatuhtempo_tgl: moment(formData.jatuhtempo_tgl).format(),
          kedatangan_tgl: moment(formData.kedatangan_tgl).format(),
          tagih_tgl: moment(formData.tagih_tgl).format(),
        });
        const res = await api?.data;
        if (res.status === 200) {
          setShowModal(false);
          defaultToastSuccess(res?.message);
          setNewDataPembelianList(formData.id);
        } else {
          defaultToastError(res?.message);
          setDisabledUpdate(SHOW_UPDATE);
        }
      }
    } catch (error) {
      setDisabledUpdate(SHOW_UPDATE);
      defaultToastError(error?.response?.data?.message);
    }
  };

  const getTotalJumlahPembelian = async () => {
    let sub_disc = 0;
    let sub_total_tanpa_disc = 0;

    await listPembelian.map((e) => {
      const subJumlah = e?.harga_satuan * e?.qty;
      const nilaiDisc = (parseFloat(e.disc) / 100) * subJumlah;
      sub_disc += nilaiDisc;
      sub_total_tanpa_disc += subJumlah;

      return true;
    });

    let jumlah = sub_total_tanpa_disc - sub_disc;

    let sub_total_dikurangi_potongan =
      jumlah - convertToValidPrice(formData.potongan2);

    let tax =
      (convertToValidPrice(formData.tax2) / 100) * sub_total_dikurangi_potongan;
    let sub_total_plus_tax = sub_total_dikurangi_potongan + tax;
    let ongkos = convertToValidPrice(formData.ongkos2);
    let biayalain = convertToValidPrice(formData.biayalain2);
    let total_jumlah =
      sub_total_plus_tax + parseFloat(ongkos) + parseFloat(biayalain);
    return convertToValidPrice(total_jumlah);
  };

  const RenderAction = () => {
    if (isNull(formData.id)) {
      return (
        <>
          <MasterButton
            className={"mt-1 w-full text-center"}
            type={"button"}
            color={disabledBukaTransaksi.color}
            name={disabledBukaTransaksi.label}
            disabled={disabledBukaTransaksi.disabled}
            onClick={(e) => disabledBukaTransaksi.disabled ? null : handleClickBukaTransaksi(e)}
            size='lg'
          />
        </>
      );
    } else {
      if (formData.status === STATUS_OPEN_DRAFT_PEMBELIAN) {
        return (
          <>
          
          <MasterButton
              className={"mt-1 w-full text-center"}
              type={"button"}
              color={disabledUpdate.color}
              onClick={(e) => disabledUpdate.disabled ? null : handleClickUpdate(e)}
              name={disabledUpdate.label}
              disabled={disabledUpdate.disabled}
              size="lg"
            />
            <MasterButton
              className={"mt-1 w-full text-center"}
              type={"button"}
              color={disabledKunci.color}
              onClick={(e) => disabledKunci.disabled ? null : handleClickTutup(e)}
              disabled={disabledKunci.disabled}
              name={disabledKunci.label}
              size='lg'
            />
           
          </>
        );
      } else if (formData.status === STATUS_PROSES_PEMBELIAN) {
        return (
          <>
            {" "}
            <MasterButton
              className={"mt-05 w-full text-center"}
              type={"button"}
              color={disabledProcess.color}
              onClick={(e) => disabledProcess.disabled ? null : handleClickProcess(e)}
              name={disabledProcess.label}
              disabled={disabledProcess.disabled}
              size='lg'
            />
               <MasterButton
              className={"mt-1 w-full text-center"}
              type={"button"}
              disabled={disabledBukaKunci.disabled}
              color={disabledBukaKunci.color}
              onClick={(e) => disabledBukaKunci.disabled ? null : handleClickBukaKembali(e)}
              name={disabledBukaKunci.label}
              size='lg'
            />

          </>
        );
      } else if (formData.status === STATUS_SELESAI_PEMBELIAN) {
        return <>Pembelian ini sudah selesai</>;
      } else {
        return <>Ada yang salah, pada status pembelian ini</>;
      }
    }
  };

  return (
    <>
      {showModalForce && (
        <ModalForce formData={formData} setShowModal={setShowModal} />
      )}

      <div
        style={{
          display: `${showModalForce ? "none" : "block"}`,
        }}>
        <Modal title={"Simpan"} width='25%' show={setShowModal}>
          <Grid
            container
            direction='row'
            alignItems='center'
            style={{
              marginBottom: "1rem",
            }}>
            <RenderAction />
          </Grid>
        </Modal>
      </div>
    </>
  );
};

export default ModalSimpan;

export function ModalForce({ setShowModal, formData }) {
  const [disabled, setDisabled] = useState(false);

  const handleForce = async (e) => {
    e.preventDefault();
    setDisabled(true);
    try {
      if (formData.gudang_id === "") {
        defaultToastError("Gudang tidak boleh kosong!");
        setDisabled(false);
      } else {
        const api = await instance4.post(urlAcceptPembelian, {
          pembelian_id: formData.id,
          gudang_id: formData.gudang_id,
          status: STATUS_SELESAI_PEMBELIAN,
          is_changesellprice: formData.is_changesellprice,
          force: true,
        });
        const res = await api?.data;
        if (res.status === 200) {
          setShowModal(false);
          defaultToastSuccess(res?.message);
        } else {
          defaultToastError(res?.message);
          setDisabled(false);
        }
      }
    } catch (error) {
      setDisabled(false);
      defaultToastError(error?.response?.data?.message);
    }
  };
  return (
    <>
      <Modal title={"Perhatian"} width={"30%"} show={setShowModal}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            gap: "20px",
            marginBottom: "1rem",
          }}>
          <WarningIcon />
          <p>
            Beberapa barang ini memiliki harga pokok lebih dari 3x lipat, apakah
            anda yakin ingin merubahnya?
          </p>
        </div>
        <Grid
          container
          direction='row'
          justifyContent='flex-end'
          alignItems='center'>
          <MasterButton
            outline={true}
            className={"mr-1 mt-1"}
            type={"button"}
            color='secondary'
            name='Batal'
            onClick={() => setShowModal(false)}
            size='md'
          />
          <MasterButton
            disabled={disabled}
            className={"mt-1"}
            type={"button"}
            color={disabled ? "secondary" : "danger"}
            onClick={handleForce}
            name={disabled ? "Loading..." : "Ya, Ubah HPP"}
            size='md'
          />
        </Grid>
      </Modal>
    </>
  );
}
